import { uid } from './model';
export const ideaKinds = {
  idea: 'Идея',
  message: 'Сообщение',
  question: 'Вопрос',
  comment: 'Комментарий',
};
export function emptyIdeaMap(title = 'Новая карта') {
  return {
    schema_version: 1,
    title,
    description: '',
    nodes: [],
    edges: [],
    comments: [],
  };
}
export function ideaNode(index = 0) {
  return {
    id: uid(),
    type: 'idea',
    position: {
      x: 80 + (index % 3) * 300,
      y: 60 + Math.floor(index / 3) * 200,
    },
    data: { kind: 'idea', title: 'Новый блок', text: '' },
  };
}
// Only planning data goes over the wire. Vue Flow's transient state, functions,
// DOM measurements, selection and visual styles are never part of a version.
export function ideaDocument(value) {
  return {
    schema_version: 1,
    title: value.title,
    description: value.description,
    nodes: value.nodes.map(n => ({
      id: n.id,
      type: 'idea',
      position: { x: n.position.x, y: n.position.y },
      data: { kind: n.data.kind, title: n.data.title, text: n.data.text },
    })),
    edges: value.edges.map(e => ({
      id: e.id,
      source: e.source,
      target: e.target,
      sourceHandle: 'yes',
      targetHandle: 'in',
      label: e.label || '',
      markerEnd: 'arrowclosed',
      data: { kind: e.data?.kind || 'transition' },
    })),
    comments: value.comments.map(c => ({
      id: c.id,
      node_id: c.node_id || null,
      text: c.text,
      resolved: Boolean(c.resolved),
    })),
  };
}
export function decorateIdeaMap(value) {
  const doc = ideaDocument(value);
  doc.edges.forEach(e => {
    e.style = {
      stroke: 'rgb(var(--slate-9))',
      strokeDasharray: e.data.kind === 'reference' ? '5 4' : 'none',
    };
    e.labelStyle = { fill: 'rgb(var(--slate-12))' };
    e.labelBgStyle = { fill: 'rgb(var(--solid-1))' };
  });
  return doc;
}
export function removeIdeaNode(document, id) {
  document.nodes = document.nodes.filter(n => n.id !== id);
  document.edges = document.edges.filter(
    e => e.source !== id && e.target !== id
  );
  document.comments = document.comments.filter(c => c.node_id !== id);
}
export function ideaError(error) {
  const code = error?.response?.data?.error;
  const messages = {
    revision_conflict:
      'Карта сохранена в другом окне. Скачайте свой черновик перед обновлением данных.',
    request_key_conflict:
      'Операция уже использована с другими данными. Обновите карту и проверьте версии.',
    invalid_document:
      'Проверьте названия, тексты и связи. Пределы: 100 блоков, 200 стрелок и 200 комментариев.',
    document_too_large:
      'Карта слишком большая. Сократите тексты или разделите её на несколько карт.',
    version_limit:
      'У карты уже 500 версий. Создайте новую карту для продолжения.',
    map_limit: 'В группе уже 100 карт.',
    storage_limit:
      'Достигнут лимит хранилища карт аккаунта. Обратитесь к администратору.',
  };
  if (error?.response?.status === 403)
    return 'Карты доступны только администратору рабочей области.';
  if (error?.response?.status === 404)
    return 'Карта, версия или группа недоступна.';
  return (
    messages[code] ||
    'Нет подтверждения от сервера. Проверьте соединение и повторите операцию.'
  );
}
